import MarkdownIt from 'markdown-it';

export const markdown = new MarkdownIt({
    html: true
});

export function renderMarkdown(data) {
    if(!data) return null;
    return markdown.render(data);
}



